// data field names
export const NAME = 'name' as const;
export const DESCRIPTION = 'description' as const;
export const TYPE = 'type' as const;
export const HIERARCHY_LEVEL = 'hierarchy-level' as const;
export const RELATED_SCHEMES = 'related-schemes' as const;
export const ACTIONS = 'actions' as const;

export const LEVEL_NUMBER = 'level-number' as const;
export const ARROW = 'arrow' as const;
export const LEVEL_NAME = 'level-name' as const;
export const JIRA_ISSUE_TYPES = 'jira-issue-types' as const;
export const LABEL_SPACE = 'label-space' as const;
